// extracted by mini-css-extract-plugin
export default {"ratingList":"StudentsProgressReports_ratingList__MpjNg","list":"StudentsProgressReports_list__CHTAU","empty":"StudentsProgressReports_empty__fJfTy"};